
export const DASHBOARD_ROUTES = {
    ROOT: "/",
    PERFORMANCE_PAGE: "performance/dashboard",
    PAYMENT_PAGE: "payments/dashboard",
    TEST_PAGE: "test/dashboard", //ONLY FOR IMPLEMENTING NEW STUFF
    DEVICE_PAGE: "Overview",
    V_CORE_CONFIGURATOR: "VCoreConfigurator",
    DEVICE_PAGE_NEW_BACKEND: "DevicesNewBackend",
    TRANSACTION_PAGE: "Transactions",
    TRANSACTION_PAGE_SERVER: "PagingTransaction",
    REPORTER_PAGE: "Reporter",
    ACTIVECAMPAIGNS_PAGE: "ActiveCampaigns",
    CAMPAIGNTOOLS_PAGE: "CampaignTools",
    POS_PAGE: "POSOverview",

    ONBOARDING: "onboard",
    ONBOARDING_STATUS: "status"

  }

  export const ADMIN_ROUTES = {
    ROOT: "/admin",
  }